import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import claimStatusGreen from '../../images/claimStatusGreen.svg';
import claimStatusMix from '../../images/claimStatusMix.svg';
import claimStatusOrange from '../../images/claimStatusOrange.svg';
import claimStatusRed from '../../images/claimStatusRed.svg';
import claimStatusBlue from '../../images/claimStatusBlue.svg';
import { get } from '..';
dayjs.extend(utc);
dayjs.extend(timezone);

export const translateLeaveStatuses: (leaveStatus?: string) => string = (
  leaveStatus,
) => {
  if (!leaveStatus) {
    return 'N/A';
  }

  const translationMap: { [key: string]: string } = {
    'Fully Adjudicated - Approved': 'Approved',
    'Fully Adjudicated - Denied': 'Denied',
    'Fully Adjudicated - Mixed Plan Decisions': 'Mixed Decision',
    'Partially Adjudicated': 'Partially Adjudicated',
  };

  const isTranslated = leaveStatus in translationMap;
  return isTranslated ? translationMap[leaveStatus] : leaveStatus;
};

export const getStatusIcon = (props: any) => {
  let statusColor = '';
  if (get(props.claim, 'status') !== undefined) {
    statusColor = get(props.claim, 'status');
  } else {
    statusColor = translateLeaveStatuses(get(props.leave, 'requestStatus'));
  }
  if (statusColor === 'Approved' || statusColor === 'Success') {
    return claimStatusGreen;
  } else if (statusColor === 'Mixed Decision' || statusColor === 'Partial') {
    return claimStatusMix;
  } else if (statusColor === 'Denied') {
    return claimStatusRed;
  } else if (
    statusColor === 'Open' ||
    statusColor === 'Intake in Progress' ||
    statusColor === 'Request Recognized' ||
    statusColor === 'Closed' ||
    statusColor === 'Archived'
  ) {
    return claimStatusBlue;
  } else {
    return claimStatusOrange;
  }
};

export const leaveStatusConfigMap: {
  keywords: string[];
  label: string;
  color: string;
  backgroundColor: string;
}[] = [
  {
    keywords: ['approved', 'success'],
    label: 'Approved',
    color: 'unm-approved',
    backgroundColor: 'unm-approved-bg',
  },
  {
    keywords: ['denied'],
    label: 'Denied',
    color: 'unm-denied',
    backgroundColor: 'unm-denied-bg',
  },
  {
    keywords: ['mixed'],
    label: 'Mixed Decision',
    color: 'unm-mixed',
    backgroundColor: 'unm-mixed-bg',
  },
  {
    keywords: ['pending'],
    label: 'Pending',
    color: 'unm-pending',
    backgroundColor: 'unm-pending-bg',
  },
  {
    keywords: ['partially', 'partial'],
    label: 'Partially Adjudicated',
    color: 'unm-pending',
    backgroundColor: 'unm-pending-bg',
  },
  {
    keywords: ['closed'],
    label: 'Closed',
    color: 'unm-interactive01-400',
    backgroundColor: 'unm-adhoc1',
  },
];

export const translateLeaveStatus = (status?: string) => {
  if (!status) {
    return {
      label: 'Unknown',
      color: 'unm-pending',
      backgroundColor: 'unm-pending-bg',
    };
  }

  const normalized = status.toLowerCase();
  const match = leaveStatusConfigMap.find(({ keywords }) =>
    keywords.some((keyword) => normalized.includes(keyword)),
  );

  return (
    match || {
      label: status,
      color: 'unm-pending',
      backgroundColor: 'unm-pending-bg',
    }
  );
};

export const getStatusBackground = (props: any) => {
  let statusColor = '';
  if (get(props.claim, 'status') !== undefined) {
    statusColor = get(props.claim, 'status');
  } else {
    statusColor = translateLeaveStatuses(get(props.leave, 'requestStatus'));
  }
  if (statusColor === 'Approved' || statusColor === 'Success') {
    return claimStatusGreen;
  } else if (statusColor === 'Mixed Decision' || statusColor === 'Partial') {
    return claimStatusMix;
  } else if (statusColor === 'Denied') {
    return claimStatusRed;
  } else if (
    statusColor === 'Open' ||
    statusColor === 'Intake in Progress' ||
    statusColor === 'Request Recognized' ||
    statusColor === 'Closed' ||
    statusColor === 'Archived'
  ) {
    return claimStatusBlue;
  } else {
    return claimStatusOrange;
  }
};
